(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vowhound-halloween-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  const SHOW_MS = 5600;
  let scheduled = false;
  let finished = false;
  let visibilityObserver = null;
  let resizeObserver = null;

  function updateDistance(host) {
    const height = host.getBoundingClientRect().height;
    host.style.setProperty('--snow-quarter-distance', Math.ceil(height / 4) + 'px');
    host.style.setProperty('--snow-mid-distance', Math.ceil(height / 2) + 'px');
    host.style.setProperty('--snow-three-quarter-distance', Math.ceil(height * .75) + 'px');
    host.style.setProperty('--snow-distance', Math.ceil(height + 28) + 'px');
  }

  // Deterministic variation keeps each snowflake smooth and lightweight.
  function random(index, salt) {
    const n = Math.sin((index + 1) * 12.9898 + salt * 78.233) * 43758.5453;
    return n - Math.floor(n);
  }

  function clearSnow() {
    finished = true;
    visibilityObserver?.disconnect();
    resizeObserver?.disconnect();
    document.querySelectorAll('#MainContent .vh-snow-host').forEach(host => {
      host.classList.remove('vh-snow-active');
      host.querySelector(':scope > .vh-snow-layer')?.remove();
    });
  }

  function showSnowOnce() {
    if (scheduled || finished) return;
    scheduled = true;
    visibilityObserver?.disconnect();
    document.querySelectorAll('#MainContent .vh-snow-host').forEach(host => {
      host.classList.add('vh-snow-active');
    });
    window.setTimeout(clearSnow, SHOW_MS);
  }

  function setupSnow() {
    if (finished || scheduled) return;
    if (!document.getElementById('vh-snow-motion')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const main = document.getElementById('MainContent');
    if (!main) return;

    if (!visibilityObserver && 'IntersectionObserver' in window) {
      visibilityObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) showSnowOnce();
      }, { rootMargin: '0px' });
    }
    if (!resizeObserver && 'ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) updateDistance(entry.target);
      });
    }

    function mount(host, type, salt) {
      if (!host || host.querySelector(':scope > .vh-snow-layer')) return;
      host.classList.add('vh-snow-host');
      host.dataset.snowType = type;
      const layer = document.createElement('span');
      layer.className = 'vh-snow-layer';
      layer.setAttribute('aria-hidden', 'true');

      const count = type === 'hero' ? 40 : 12;
      for (let i = 0; i < count; i++) {
        const flake = document.createElement('span');
        flake.className = 'vh-snow-flake';
        const depth = random(i, salt + 9);
        const duration = 9.5 - depth * 2.5 + random(i, salt + 1) * 4;
        const drift = (random(i, salt + 5) - .5) * (50 + depth * 38);
        const gust = (random(i, salt + 8) - .5) * 19;
        flake.style.left = (random(i, salt + 2) * 100).toFixed(1) + '%';
        flake.style.setProperty('--snow-size', (1.5 + depth * 4.1).toFixed(1) + 'px');
        flake.style.setProperty('--snow-blur', (.04 + depth * depth * 1.1).toFixed(2) + 'px');
        flake.style.setProperty('--snow-glow', (.8 + depth * 2.4).toFixed(1) + 'px');
        flake.style.setProperty('--snow-duration', duration.toFixed(1) + 's');
        flake.style.setProperty('--snow-delay', (-random(i, salt + 4) * duration).toFixed(1) + 's');
        flake.style.setProperty('--snow-quarter-drift', (drift * .24 + gust * .45).toFixed(0) + 'px');
        flake.style.setProperty('--snow-mid-drift', (drift * .5 + gust).toFixed(0) + 'px');
        flake.style.setProperty('--snow-three-quarter-drift', (drift * .75 - gust * .5).toFixed(0) + 'px');
        flake.style.setProperty('--snow-drift', drift.toFixed(0) + 'px');
        flake.style.setProperty('--snow-opacity', (.43 + depth * .42).toFixed(2));
        layer.appendChild(flake);
      }

      host.appendChild(layer);
      updateDistance(host);
      resizeObserver?.observe(host);
      if (visibilityObserver) visibilityObserver.observe(host);
      else showSnowOnce();
    }

    const title = main.querySelector('h1');
    mount(main.querySelector('.vh-top-hero') || title?.closest('.shopify-section'), 'hero', 11);

    const links = new Set();
    for (const img of main.querySelectorAll('a[href*="/products/"] img')) {
      const link = img.closest('a');
      if (!link || links.has(link) || /phone.case/i.test(img.alt + ' ' + link.href)) continue;
      if (links.size >= 4) break;
      links.add(link);
      mount(link, 'card', links.size * 29);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupSnow, { once: true });
  } else {
    setupSnow();
  }
  document.addEventListener('shopify:section:load', setupSnow);
})();
  } catch(e) { console.error(e); }
})();

})();
